import React, {FC} from "react"
import PropTypes from "prop-types"

import {Label} from "@irati/ui/src/Typography"
import Spacing from "@irati/ui/src/Spacing"
import FormattedMessage from "@irati/utils/lang"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import theme from "@irati/ui/src/global/theme"
import Flex from "@irati/ui/src/Flex"

import {StyledRouterLink, BlueCircle} from "./styled"

interface Props {
  text: string
  to?: string
}

interface Context {
  apps: {[key: string]: string}
}

const ViewLink: FC<Props> = ({text, to = "/"}, {apps}: Context) => {
  return (
    <Spacing marginTop={2}>
      <StyledRouterLink to={to} app={apps.RECOGNITION}>
        <Flex gap={theme.spacing.one} justifyContent="flex-end">
          <Label small color={theme.colors.primary1}>
            <FormattedMessage id={text} />
          </Label>
          <BlueCircle alignItems="center" justifyContent="center">
            <Icon icon={IconTypes.arrowRight} color={theme.colors.greys.white} />
          </BlueCircle>
        </Flex>
      </StyledRouterLink>
    </Spacing>
  )
}

ViewLink.contextTypes = {
  apps: PropTypes.object.isRequired
}

export default ViewLink
